module.exports = __webpack_public_path__ + "img/vuejs.9a45fc76.svg";